import Icon from '../../components/Icon.vue'

Icon.register({"brands/deviantart":{"width":320,"height":512,"paths":[{"d":"M320 93.2L221.8 272.3 229.2 281.8H320V409.5H159.1L145.6 418.7 101.9 502.7C101.6 502.7 93.3 511.3 92.7 511.9H0V418.7L93.2 239.3 85.8 230.1H0V102.5H156L169.5 93.3 213.2 9.3C213.5 9.3 221.8 0.7 222.4 0.1H320V93.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/deviantart.js
// module id = qE70
// module chunks = 0